import { ButtonWithTooltip } from "@risalabs_frontend_org/oasis-ui-kit";
import { useEffect, useState } from "react";
import { SpinningLoader } from "risa-oasis-ui_v2";
import { postRequestForRefreshTemplates } from "../../../../../api/postCall/refreshNotes";
import ValidationMessageList from "../../../../../components/validationMessageList/validationMessageList";
import { useAbortableFetch } from "../../../../../hooks/useAbortableFetch";
import { handleRefreshTemplates } from "../actionHandlers/handleRefreshTemplate";
import {
  RpaBlockers,
  useBoNotesValidationMessages,
} from "../hooks/useBoNotesValidationMessages";

interface BusniessOfficeNotesHeaderProps {
  /** Individual RPA blockers used to build the button tooltips. */
  rpaBlockers: RpaBlockers;
  saveBoLoading: boolean;
  handleSaveBoNotes: () => void;
  handleTriggerRpa: () => void;
  orderId: string;
  fetchAll: () => Promise<void>;
  siblingOrderIds: string[];
}

const BusniessOfficeNotesHeader = (props: BusniessOfficeNotesHeaderProps) => {
  const {
    rpaBlockers,
    saveBoLoading,
    handleSaveBoNotes,
    handleTriggerRpa,
    orderId,
    fetchAll,
    siblingOrderIds,
  } = props;
  const { runFetch, loading, abort } = useAbortableFetch(
    (signal: AbortSignal) =>
      postRequestForRefreshTemplates(orderId, siblingOrderIds, signal),
  );
  const [refreshTemplatesLoading, setRefreshTemplatesLoading] = useState(false);

  const {
    saveBoMessages,
    isSaveBoDisabled,
    triggerRpaMessages,
    isTriggerRpaDisabled,
  } = useBoNotesValidationMessages({ rpaBlockers, saveBoLoading });

  useEffect(() => {
    return () => {
      abort();
    };
  }, []);

  return (
    <div className="flex justify-end gap-1">
      <div
        className="refresh-template-action flex items-center justify-center text-sm font-bold text-tertiaryBlue-4 hover:cursor-pointer hover:text-tertiaryBlue-4/80"
        onClick={() =>
          handleRefreshTemplates(runFetch, loading, async () => {
            setRefreshTemplatesLoading(true);
            await fetchAll();
            setRefreshTemplatesLoading(false);
          })
        }
      >
        {loading || refreshTemplatesLoading ? (
          <SpinningLoader />
        ) : (
          "Refresh Templates"
        )}
      </div>
      <ButtonWithTooltip
        showTooltip={isSaveBoDisabled}
        tooltipContent={<ValidationMessageList messages={saveBoMessages} />}
        buttonType="tertiary"
        size="medium"
        disabled={isSaveBoDisabled}
        onClick={handleSaveBoNotes}
      >
        {saveBoLoading ? "Saving..." : "Save BO Notes"}
      </ButtonWithTooltip>
      <ButtonWithTooltip
        showTooltip={isTriggerRpaDisabled}
        tooltipContent={<ValidationMessageList messages={triggerRpaMessages} />}
        buttonType="secondary"
        size="medium"
        disabled={isTriggerRpaDisabled}
        onClick={handleTriggerRpa}
      >
        Trigger RPA
      </ButtonWithTooltip>
    </div>
  );
};

export default BusniessOfficeNotesHeader;
